import { IconButton, Theme } from '@mui/material';
import React, {
  CSSProperties,
  ChangeEvent,
  KeyboardEvent,
  useEffect,
  useState
} from 'react';

import CloseIcon from '@mui/icons-material/Close';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { useDebounce } from '../../content/hooks/useDebounce';

interface SearchTextFieldProps {
  autoFocus?: boolean;
  disabled?: boolean;
  style?: CSSProperties;
  trigger?: 'type' | 'enter' | number;
  placeholder?: string;
  searchText?: string;
  onSearch: (text: string) => void;
}

const SearchTextField = (props: SearchTextFieldProps) => {
  const { trigger } = props;
  const [value, setValue] = useState(props.searchText || '');
  const debounced =
    typeof trigger === 'number' ? useDebounce(value, trigger) : null;
  useEffect(() => {
    if (debounced !== null) {
      props.onSearch(debounced);
    }
  }, [debounced]);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    if (!trigger || trigger === 'type') {
      props.onSearch(e.target.value);
    }
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (trigger === 'enter' && e.key === 'Enter') {
      e.preventDefault();
      props.onSearch(value);
    }
  };

  const onClear = () => {
    setValue('');
    props.onSearch('');
  };

  return (
    <TextField
      variant="outlined"
      margin="dense"
      size="small"
      label={props.placeholder ? undefined : 'Search'}
      value={value}
      autoFocus={props.autoFocus}
      disabled={props.disabled}
      style={props.style}
      placeholder={props.placeholder}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              sx={value ? { visibility: 'visible' } : { visibility: 'hidden' }}
              onClick={onClear}
            >
              <CloseIcon />
            </IconButton>
          </InputAdornment>
        )
      }}
      onChange={onChange}
      onKeyPress={handleKeyPress}
    />
  );
};

export default SearchTextField;
